export const publicPath = (path = '') =>
    process.env.PUBLIC_URL ? `${process.env.PUBLIC_URL}/${path}` : `/${path}`;
